import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects, authLoginReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([AuthEffects]), StoreModule.forFeature(`login`, authLoginReducer)]
})
export class AuthLoginStateModule {}
